module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel02_1280_1280_zh-hant-93b53f067b14feb4e36c02143baccf41.jpg";